import Vue from "vue";
import App from "@/views/App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import "babel-polyfill";
import "./assets/global-variables.scss";
import VeeValidate, { Validator } from "vee-validate";
import ja from "vee-validate/dist/locale/ja";
import Amplify from "aws-amplify";
import { environment } from "./aws-exports";
import "@/store/service/axios-interceptor";
import "moment/locale/ja";

Amplify.configure(environment);

Vue.use(Buefy);
Vue.use(VeeValidate);
Validator.localize("ja", ja);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
